import { render } from "./DropDownListBibLocalizacao.vue?vue&type=template&id=6fa2b079&ts=true"
import script from "./DropDownListBibLocalizacao.vue?vue&type=script&lang=ts"
export * from "./DropDownListBibLocalizacao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__